import React from 'react';
import { observer } from 'mobx-react-lite';
import { BonusCreationState } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/BonusCreation.state';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { MultiSelectList } from 'src/domains/common/components/multi-select-list/multi-select-list';

export type SportsPickerPropsType = {
    state: BonusCreationState | CampaignCreatorState;
    disabled?: boolean;
};

export const RewardSportsPicker = observer(({ state, disabled }: SportsPickerPropsType): JSX.Element => {
    const rewardSportsPickerState = state.rewardConditionsState.sportsBookSectionState.sportsPickerState;

    const {
        showAllBadges,
        expanded,
        visibleCheckedWithLabels,
        visibleChecked,
        filteredNodes,
        keywordInputState,
        checked,
        isLoading,
        toggleShowAllBadges,
        clearChecked,
        handleCheck,
        handleExpand,
        setKeyword,
        handleRemoveChecked,
    } = rewardSportsPickerState;

    return (
        <div className='flex flex-col gap-2 relative'>
            {isLoading && (
                <div className='absolute top-0 left-0 right-0 bottom-0 flex flex-col items-center justify-center flex-auto gap-6 p-6 bg-white/75 font-tertiary flex-nowrap animate-pulse'>
                    <div className='w-8 h-8 border-4 border-dashed rounded-full animate-spin border-foreground' />
                </div>
            )}
            <MultiSelectList
                filteredNodes={filteredNodes}
                showAllBadges={showAllBadges}
                checked={checked}
                visibleChecked={visibleChecked}
                keywordInputState={keywordInputState}
                expanded={expanded}
                visibleCheckedWithLabels={visibleCheckedWithLabels}
                toggleShowAllBadges={toggleShowAllBadges}
                clearChecked={clearChecked}
                handleCheck={handleCheck}
                handleExpand={handleExpand}
                setKeyword={setKeyword}
                handleRemoveChecked={handleRemoveChecked}
                remaining={visibleChecked.remaining}
                remainingLabel='Items'
                disabled={disabled}
            />
        </div>
    );
});
